// extracted by mini-css-extract-plugin
export var aggregationCell = "_2p-n";
export var aggregationRow = "_2p-m";
export var borderlessSpinnerContainer = "_2p-3";
export var cardLayout = "_2p-6";
export var cardLayoutNoFooter = "_2p-9";
export var cardLayoutPageControl = "_2p-8";
export var closeIcon = "_2p-f";
export var columnHeaderSurface = "_2p-b";
export var columnHeaderSurfaceDragOverlay = "_2p-v";
export var columnHeaderSurfaceResizing = "_2p-s";
export var contextMenuAnchor = "_2p-1";
export var draggableColumnHeader = "_2p-t";
export var draggableColumnHeaderOverlay = "_2p-u";
export var expandIcon = "_2p-g";
export var expanded = "_2p-h";
export var filterDropdown = "_2p-i";
export var filterDropdownDivider = "_2p-d";
export var filterDropdownHeader = "_2p-l";
export var filterDropdownItem = "_2p-k";
export var filterDropdownModal = "_2p-j _2p-i";
export var filterItem = "_2p-c";
export var normalCellWithAdjustableBorder = "_2p-e";
export var pinButtonContainer = "_2p-o";
export var pinIcon = "_2p-p";
export var pinIconActive = "_2p-q";
export var spinner = "_2p-0";
export var spinnerContainer = "_2p-2";
export var tableContainer = "_2p-4";
export var tableContentDraggingColumns = "_2p-a";
export var tableContentInner = "_2p-7";
export var tableContentWrapper = "_2p-5";
export var viewButtonContainer = "_2p-r";